import React, { FC } from "react";
import Link from "next/link";
import { FacebookIconRounded } from "@components/icons/facebook-icon-rounded";
import { LinkedinIconRounded } from "@components/icons/linkedin-icon-rounded";
import { InstagramIconRounded } from "@components/icons/instragram-icon-rounded";
import { TwitterIconRounded } from "@components/icons/twitter-icon-rounded";
import { YoutubeIconRounded } from "@components/icons/youtube-icon-rounded";
import { MapLocation } from "@components/icons/map-location";
import { Building } from "@components/icons/building";
import { Phone } from "@components/icons/phone";
import { At } from "@components/icons/at";
import { PagePropsBasicType } from "../../../@types/types-body";
import Image from "next/image";
import Contact from "@images/contact.webp";
import {DiscordIcon} from "@components/icons/discord-icon";

const CompanyInfo: FC<PagePropsBasicType> = ({ namespace }) => {
  return (
    <section className="w-full bg-white" key={namespace}>
      <div className="grid grid-cols-1 md:grid-cols-2 bg-crowlyn-night text-white ">
        <div className="px-12 py-12 md:py-4">
          <div className="relative mb-4">
            <h3 className="text-3xl leading-tight font-bold my-4">
              Crowlyn, s.r.o.
            </h3>
            <Link
              href="https://goo.gl/maps/2YNQsiazUV8Xfs7Q7"
              className="group mt-2 leading-relaxed underline text-white hover:text-crowlyn-light flex"
            >
              <div className="w-6 h-6 fill-white group-hover:fill-crowlyn-light mr-2">
                {MapLocation}
              </div>
              Varšavská 715/36, 120 00 Praha-Vinohrady
            </Link>
          </div>
          <div className="my-10">
            <p className="leading-relaxed m-0">
              <span className="mr-2">DIC:</span>CZ17174503
            </p>
            <p className="leading-relaxed m-0">
              <span className="mr-2">ICO:</span>17174503
            </p>
          </div>
          <div className="my-1 leading-relaxed flex  align-bottom">
            <div className="w-4 h-4 fill-white mr-2 my-auto align-bottom">
              {At}
            </div>
            info@crowlyn.com
          </div>
          <div className="my-1 leading-relaxed flex  align-bottom">
            <div className="w-4 h-4 fill-white mr-2 my-auto align-bottom">
              {Phone}
            </div>
            +49 1512 3376347 || +420 730 233 000
          </div>
          <div className="my-1 leading-relaxed flex  align-bottom">
            <div className="w-4 h-4 fill-white mr-2 my-auto  align-bottom">
              {Building}
            </div>
            Společnost je zapsána v obchodním rejstříku vedeném u Městského
            soudu v Praze, oddílu C vložce 367743/MSPH
          </div>
          <div className="flex justify-start space-x-3 mt-8">
            <Link
              href="https://www.facebook.com/CrowlynCompany/"
              target="_blank"
              rel="noopener"
              className="fill-white hover:fill-crowlyn-light "
            >
              <FacebookIconRounded />
            </Link>
            <Link
              href="https://www.linkedin.com/company/crowlyn/"
              target="_blank"
              rel="noopener"
              className="fill-white hover:fill-crowlyn-light"
            >
              <LinkedinIconRounded />
            </Link>
            <Link
              href="https://www.instagram.com/crowlyncompany/"
              target="_blank"
              rel="noopener"
              className="fill-white hover:fill-crowlyn-light"
            >
              <InstagramIconRounded />
            </Link>
            <Link
              href="https://twitter.com/CrowlynCompany"
              target="_blank"
              rel="noopener"
              className="fill-black bg-white hover:bg-crowlyn-light rounded"
            >
              <TwitterIconRounded />
            </Link>
            <Link
              href="https://discord.gg/qRUyVwRXQq"
              target="_blank"
              rel="noopener"
              className="fill-black bg-white hover:bg-crowlyn-light rounded"
            >
              <DiscordIcon />
            </Link>
            <Link
              href="https://www.youtube.com/channel/UCGNCzE32mjuYtGUn3mlPJ9g"
              rel="noopener"
              target="_blank"
              className="fill-white hover:fill-crowlyn-light"
            >
              <YoutubeIconRounded />
            </Link>
          </div>
        </div>
        <div className="w-full h-full relative">
          <Image
            src={Contact}
            fill={false}
            className={"w-full h-full"}
            alt={"Crowlyn"}
          />
        </div>
      </div>
      <div className={"w-full h-60"}>
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2560.685249008222!2d14.436397815736548!3d50.073455979425084!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x470b948607fbf421%3A0x3024c3f46276cbc0!2sVar%C5%A1avsk%C3%A1%20715%2F36%2C%20120%2000%20Vinohrady!5e0!3m2!1sen!2scz!4v1667202804867!5m2!1sen!2scz"
          width="100%"
          height="100%"
          loading="lazy"
          className="w-full h-full"
          referrerPolicy="no-referrer-when-downgrade"
        ></iframe>
      </div>
    </section>
  );
};

export default CompanyInfo;
